/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme} from 'components/shared/theme';
import {ConfirmButton} from 'components/buttons';

const {colors, fontSizeXxxl, spacing} = theme;

export const Content = styled.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  color: ${colors.gray200};
  h1 {
    font-size: ${fontSizeXxxl};
    font-weight: bolder;
    text-transform: capitalize;
    color: ${colors.gray500};
  }
  a {
    max-width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: ${spacing.medium} 0;
    border: none;
    color: ${colors.gray200};

    span {
      margin: 0 ${spacing.xxSmall};
    }
  }
`;

export const Button = styled.default(ConfirmButton)`
  margin: ${spacing.medium} 0;
  border: none;
  color: ${colors.gray900};
`;